import React, { FC, useCallback, useEffect } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import VideoComponent from '../../shared/VideoComponent';
import ButtonBack from '../../shared/buttonComponents/ButtonBack';
import { useHistory } from 'react-router-dom';
import { getGrade, Grade } from '../../../helpers/grading';

export const MonthlyVolumePage: FC = () => {
  const {
    updateStepData,
    changeStep,
    data
  } = useWizard();

  const DisplayedGrade: Grade = getGrade(data);


  const handleSelect = useCallback((expectedMonthlyVolume) => {
    updateStepData({
      expectedMonthlyVolume
    });

    if (data.countryTier === 'Tier 4 - Prohibited' || data.industryRisk === 'Prohibited') {
      changeStep(WizardStep.SORRY);
    } else if (data.customIndustry !== '' || data.subIndustry === 'Other') {

      changeStep(WizardStep.OTHER_FORM);
    } else if (DisplayedGrade === Grade.F) {
      changeStep(WizardStep.SORRY);

    } else {
      changeStep(WizardStep.PROPOSAL);
    }

  }, [DisplayedGrade,changeStep, data.countryTier, data.customIndustry, data.industryRisk, data.subIndustry, updateStepData]);

  let history = useHistory();
// use destructuring to access the history property of the ReactComponentProps type

  // use useEffect to access lifecycle methods, as componentDidMount etc. are not available on function components.
  useEffect(() => {

    return () => {
      if (history.action === 'POP') {
        // Code here will run when back button fires.
        // Note that it's after the `return` for useEffect's callback;
        // code before the return will fire after the page mounts,
        // code after when it is about to unmount.
        changeStep(WizardStep.COMPANY_TYPE);
      }
    };
  });

  return (
    <Layout>
      <div className="monthly-volume-page-container">

        <div className="monthly-volume-page-right-mobile">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/monthly-volume.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/monthly-volume.png`}
          />
        </div>

        <div className="monthly-volume-page-left">
          <div className="secondary-title">{data.companyYears} year{data.companyYears === 1 ? '' : 's'} - RESPECT!</div>
          <div className="main-title">Expected monthly<br/> volume?</div>

          <div className="monthly-volume-page-list">
            <div
              onClick={() => handleSelect('0 - 100K')}
              className="monthly-volume-page-item item-one"
            >
              0 - 100K
            </div>
            <div
              onClick={() => handleSelect('100K - 500K')}
              className="monthly-volume-page-item item-two"
            >
              100K - 500K
            </div>
            <div
              onClick={() => handleSelect('500K - 2M')}
              className="monthly-volume-page-item item-three"
            >
              500K - 2M
            </div>
            <div
              onClick={() => handleSelect('2M - 5M')}
              className="monthly-volume-page-item item-four"
            >
              2M - 5M
            </div>
            <div
              onClick={() => handleSelect('5M - And Above')}
              className="monthly-volume-page-item item-five"
            >
              5M - And Above
            </div>
          </div>
        </div>

        <div className='monthly-volume-page-button'>
          <ButtonBack
            disabled={false}
            onClick={() => changeStep(WizardStep.COMPANY_TYPE)}
            title="Back"
          />
        </div>

        <div className="monthly-volume-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/monthly-volume.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/monthly-volume.png`}
          />
        </div>
      </div>
    </Layout>
  );
};
